import { categories, heroImage } from '@/mocks/animeData';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-800',
};

export default function Hero() {
  return (
    <section id="home" className="relative">
      <div className="relative flex min-h-[560px] w-full flex-col items-center justify-center overflow-hidden">
        <img
          src={heroImage}
          alt="卡通动漫第一页 动漫漫画聚合首页背景插画"
          title="卡通动漫第一页 今日更新 热门榜单 编辑推荐"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/60 via-background-950/40 to-background-50"></div>

        <div className="relative z-10 flex w-full flex-col items-center px-4 text-center">
          <span className="mb-4 inline-flex items-center gap-1.5 rounded-full bg-background-50/15 px-4 py-1.5 text-sm font-medium text-background-50 backdrop-blur-sm">
            <i className="ri-fire-fill text-secondary-400"></i>
            每日更新不重样 · 漫画迷的追更必备
          </span>
          <h1 className="font-heading max-w-3xl text-3xl leading-tight text-background-50 md:text-5xl">
            卡通动漫第一页
          </h1>
          <p className="mt-4 max-w-2xl text-base leading-7 text-background-100 md:text-lg">
            今日更新、热门榜单、编辑推荐、新作首发、高分漫画与人气连载一站聚合。
            想看什么直接挑，打开就是精彩。
          </p>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <a
              href="#today"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-7 py-3 text-sm font-bold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
            >
              <i className="ri-refresh-line"></i>
              查看今日更新
            </a>
            <a
              href="#editor"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-background-50 text-foreground-950 px-7 py-3 text-sm font-bold whitespace-nowrap transition-colors hover:bg-background-100"
            >
              <i className="ri-star-smile-fill text-secondary-500"></i>
              看看编辑推荐
            </a>
          </div>
        </div>
      </div>

      <div className="relative z-10 -mt-10 px-4 md:px-6">
        <div className="mx-auto grid max-w-6xl grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
          {categories.map((c) => (
            <a
              key={c.name}
              href="#today"
              className="group flex items-center justify-center gap-2 rounded-lg border border-background-200 bg-background-50 px-2 py-4 transition-colors hover:border-primary-300"
            >
              <span
                className={`inline-flex h-8 w-8 items-center justify-center rounded-md ${colorMap[c.color]}`}
              >
                <i className={`${c.icon} text-base`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">
                {c.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}